import {createSelector} from '@reduxjs/toolkit';

import {selectGeneralSettings} from '../generalSettings/selectors';

export const selectVehicleSettings = createSelector(
  selectGeneralSettings,
  (state) => state.vehicleSettings
);
